export default function AppointmentsList({ appointments, loading }: any) {

  const getStatoColor = (stato: string) => {
    switch (stato) {
      case "AttesaConsulenza":
        return "bg-yellow-100 text-yellow-800";

      case "DaRegistrare":
        return "bg-blue-100 text-blue-800";

      case "Eseguita":
        return "bg-green-100 text-green-800";

      default:
        return "bg-gray-100 text-gray-800";
    }
  };

  const replaceStato = (esito: string) => {
    let split = esito.split(/(?=[A-Z])/);
    return `${split[0]} ${split[1] ? split[1]?.toLowerCase() : ""} ${
      split[2] ? split[2]?.toLowerCase() : ""
    }`;
  };

  if (loading) {
    return (
      <div className="text-center text-gray-500 py-8">
        Caricamento appuntamenti...
      </div>
    );
  }

  if (appointments.length === 0) {
    return (
      <div className="text-center text-gray-500 py-8">
        Nessun appuntamento per questo giorno
      </div>
    );
  }

  return (
    <div className="space-y-3">

      {appointments.map((app: any) => (
        <div
          key={app.codiceOspite}
          className="flex items-start gap-4 p-3 rounded-lg hover:bg-gray-50 transition border border-gray-200"
        >

          {/* ORARIO */}
          <div
            className={`text-sm w-16 shrink-0 ${
              app.limiteRaggiunto
                ? "text-red-600 font-bold"
                : "text-gray-600 font-semibold"
            }`}
          >
            {app.orario.slice(0, 5)}
          </div>

          {/* TIMELINE */}
          <div className="relative">
            <span className="absolute top-2 left-0 w-2 h-2 bg-emerald-700 rounded-full"></span>
          </div>

          {/* CONTENUTO */}
          <div className="flex-1">

            <div className="flex justify-between items-start">

              <div>

                <div className="font-semibold text-gray-800">
                  {app.nome} {app.cognome}
                </div>

                <div className="text-xs text-gray-500">
                  Codice: {app.codiceOspite}
                </div>

                {app.azienda && (
                  <div className="text-xs text-gray-500">
                    {app.azienda}
                  </div>
                )}

              </div>

              <span
                className={`px-2 py-1 rounded-full text-xs font-semibold whitespace-nowrap ${getStatoColor(
                  app.statoIntervista
                )}`}
              >
                {replaceStato(app.statoIntervista)}
              </span>

            </div>
          </div>
        </div>
      ))}

    </div>
  );
}